/**
 * A layout says WHERE things are in a workbook, sheet by sheet: the anchors the
 * parser reads from. Cell references (A1-style), column letters and a role —
 * never a value. It is produced by the locator (@agio/locate) from a model's
 * answer, shown to and confirmed by an admin, and consumed by the pipeline
 * parser in place of its default rules for the sheets it names.
 */
/** The 12 sleeve columns of the wide holdings table, in SLEEVES order. */
export const SLEEVE_KEYS = [
    'stocks_il',
    'stocks_foreign',
    'commodities',
    'bonds_cpi_corp',
    'bonds_cpi_gov',
    'bonds_foreign',
    'bonds_nis_corp',
    'bonds_nis_gov',
    'money_market',
    'cash_ils',
    'cash_fx',
    'alternatives',
];
/** The seven monthly series of a performance sheet, as the parser names them. */
export const PERF_SERIES = [
    'asset_volume',
    'deposits',
    'withdrawals',
    'monthly_return',
    'cumulative_return',
    'benchmark_cumulative',
    'benchmark_monthly',
];
// ---------------------------------------------------------------------------
// The whole-portfolio summary sheet (סיכום): which rows hold the series.
// ---------------------------------------------------------------------------
/** The four whole-portfolio series a summary sheet can carry, one row each. */
export const SUMMARY_SERIES = ['monthly_return', 'cumulative_return', 'benchmark_monthly', 'benchmark_cumulative'];
//# sourceMappingURL=layout.js.map